import { Button, ButtonsGroup, Modal, useModal } from '@billy/design-system'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface LegalGuaranteeOfConformityModalFooterProps {
  id: string
  onEnableChange: (isEnabled: boolean) => void
}

export const LegalGuaranteeOfConformityModalFooter = ({
  id,
  onEnableChange,
}: LegalGuaranteeOfConformityModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { close: closeModal } = useModal(id)

  const handleEnableChange = useCallback(
    (isEnabled: boolean) => {
      onEnableChange(isEnabled)
      closeModal()
    },
    [closeModal, onEnableChange],
  )

  const handleKeepOffButtonClick = useCallback(() => {
    handleEnableChange(false)
  }, [handleEnableChange])

  const handleEnableButtonClick = useCallback(() => {
    handleEnableChange(true)
  }, [handleEnableChange])

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button onClick={handleKeepOffButtonClick} variant="text">
          {t('settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.keep_off')}
        </Button>
        <Button onClick={handleEnableButtonClick}>
          {t('settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.enable')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
